import { Divider } from '@mui/material';
import * as React from 'react';
import { useMemo } from 'react';
import * as TFF from '@tff/types/TFF';
import { useIntl } from 'react-intl';
import TFFTypography from '../../styled-components/TFFTypography';
import TFFIcon from '../../styled-components/TFFIcon';
import { useBookingContext } from '../../hooks/use-booking-context';

interface BookingPricesProps {
  orderDetails: TFF.OrderDetails;
  orderSummary: TFF.OrderSummary | undefined;
  onDetailClick: () => void;
}

const BookingPrices: React.FC<BookingPricesProps> = ({ orderDetails, orderSummary, onDetailClick }) => {
  const intl = useIntl();
  const { numberFormatter } = useBookingContext();

  const taxes = useMemo(() => {
    let _taxes = 0;
    if (!orderDetails.Fares) {
      return _taxes;
    }
    const fares = Object.values(orderDetails.Fares);
    fares.forEach(f => {
      _taxes += f.TotalFeesAndTaxesAmountIncluded ?? 0;
      _taxes += f.TotalFeesAndTaxesAmountExcluded ?? 0;
    });
    return _taxes;
  }, [orderDetails]);

  const flightPrice = (orderSummary?.TotalFarePrice ?? 0) - taxes;
  const ancillariesPrice = orderSummary?.TotalAncillaryPrice ?? 0;
  const sumPrice = (orderSummary?.TotalFarePrice ?? 0) + (orderSummary?.TotalAncillaryPrice ?? 0);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <TFFTypography text={intl.formatMessage({ id: 'pricingDetails.flightPrice' })} />
        <TFFTypography text={numberFormatter.format(flightPrice)} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <TFFTypography text={intl.formatMessage({ id: 'pricingDetails.taxAndFees' })} />
        <TFFTypography text={numberFormatter.format(taxes)} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <TFFTypography text={intl.formatMessage({ id: 'pricingDetails.ancillaries' })} />
        <TFFTypography text={numberFormatter.format(ancillariesPrice)} />
      </div>
      <Divider
        sx={{
          backgroundColor: '#BABABA',
          margin: '4px 0px',
          height: '2px',
        }}
      />
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
          <TFFTypography fontWeight="bold" text={intl.formatMessage({ id: 'pricingDetails.sum' })} />
          <span onClick={onDetailClick} style={{ cursor: 'pointer' }}>
            <TFFIcon color="color-theme-variant" iconName="link-external" />
          </span>
        </div>
        <TFFTypography fontWeight="bold" text={numberFormatter.format(sumPrice)} />
      </div>
    </>
  );
};

export default BookingPrices;
